















import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { surveyAnalyzeModule } from '@/store/modules/frames/survey-analyze.module';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GTemplateTopicForm from '@/components/GTopicForm.vue';
import GSurveyAnalyzeFilter from '@/views/GSurveyAnalyze/GSurveyAnalyzeFilter.vue';
import GSurveyChart from '@/views/GSurveyAnalyze/GSurveyChart.vue';
import GStatisticsChart from '@/views/GStatistics/GStatisticsChart.vue';
import GLoading from '@/components/GLoading.vue';
import GStatisticsBoxplotSubTableInfoTable from '@/components/GStatisticsBoxplotSubTableInfoTable.vue';
import { SurveyAnalysisTabelMapping } from '@/models/jgrow/survey-analysis-tabel-mapping';
import GOptionalData from '@/components/GOptionalData.vue';

@Component({
  name: 'GSurveyMetaawarenessAnalyze',
  components: {
    GLoading,
    GSurveyChart,
    GSurveyAnalyzeFilter,
    GTemplateTopicForm,
    GTitleBar,
    GCustomBreadCrumb,
    GStatisticsChart,
    GOptionalData,
    GStatisticsBoxplotSubTableInfoTable,
  },
  computed: {},
  methods: {},
})
export default class GSurveyMetaawarenessAnalyze extends mixins(GPageBase) {
  columns: any[] = []; // テーブル形式のテーブルカラム情報
  surveyAnalysisTabel: SurveyAnalysisTabelMapping = new SurveyAnalysisTabelMapping();

  items: string[] = [
    '1:全く意欲が高まらない',
    '2:意欲が高まらない',
    '3:どちらかと言えば意欲が高まらない',
    '4:どちらとも言えない',
    '5:どちらかと言えば意欲が高まった',
    '6:意欲が高まった',
    '7:非常に意欲が高まった',
  ];
  @Prop() competencyID: number;

  async mounted() {
    this.columns = [
      {
        title: '7段階中',
        key: 'title',
        width: 260,
        align: 'center',
        slot: 'title',
      },
      {
        title: '人数',
        key: 'count',
        width: 50,
        align: 'center',
        slot: 'count',
      },
    ];

    const rateTables: Map<number, SurveyAnalysisTabelMapping> = await surveyAnalyzeModule.getCompetencyAnswerTabels();
    this.surveyAnalysisTabel = rateTables.get(this.competencyID);
    this.surveyAnalysisTabel.pointList.splice(this.surveyAnalysisTabel.pointList.length - 1, 1);
  }

  getCompetencyName(id: number): string {
    return surveyAnalyzeModule.competencyNameMap.get(id);
  }
}
